import { ref, watch } from 'vue'

// Device-local preference: auto-play word/term audio when a new answer card
// appears. Defaults ON; only the "off" state is persisted (read with
// !== 'false'), mirroring the other speaksaigon_* prefs (e.g. strictTones).
const KEY = 'speaksaigon_autoplay_audio'

function initial() {
  try {
    return localStorage.getItem(KEY) !== 'false'
  } catch (e) {
    return true
  }
}

// Shared reactive ref so every toggle instance + every autoplay-gating check
// stay in sync within a session.
export const autoplayEnabled = ref(initial())

watch(autoplayEnabled, (v) => {
  try {
    localStorage.setItem(KEY, v ? 'true' : 'false')
  } catch (e) {
    /* ignore (private mode) */
  }
})
